import { Modal } from 'components/lib';
import React from 'react';

type BasicImageModalProps = {
  onDismiss: () => void;
  url: string;
  name: string;
  title?: string;
};

const BasicImageModal: React.FC<BasicImageModalProps> = ({
  onDismiss,
  url,
  name,
  title = 'Image Attachment',
}) => {
  return (
    <Modal title={title} size="xlarge" onDismiss={onDismiss}>
      <div className="flex-center h90 w100">
        <img className="h90 w90 of-contain" src={url} alt={name} />
      </div>
    </Modal>
  );
};

export default BasicImageModal;
